module.exports = __webpack_public_path__ + "img/logo-race.a953de00.png";